import * as _ from "lodash"
import { BatchScopeBO } from "./BatchScopeBO";
import { ErrorMessage_restate } from "../PA.Core/Basic/MessageUtils";
import { esWB_BatchScope } from "../PA.Core/PAdbSchema";

function isEmptyTrim(a: any): boolean {
    if(_.isEmpty(a))
        return true
    if(_.isString(a))
        return _.isEmpty(a.trim())
    return false
}

export class BatchScopeBOValidations {


    static async Validate(aBO: BatchScopeBO): Promise<void> {
        let mp = aBO.ValidateMessageProvider
        let dr = aBO.WB_BatchScope.cif
        mp.clearMessages()
        dr.BATCHSCOPE_NAME = dr.BATCHSCOPE_NAME.trim()
        let bNameEmpty = _.isEmpty(dr.BATCHSCOPE_NAME.trim())
        ErrorMessage_restate(mp, bNameEmpty, 'EmptyName', 'Batch Scope name is not set')

        if(!bNameEmpty){
            // Check Uniqueness
            let dups = await aBO.dbContext.findAll(esWB_BatchScope, {
                where: {
                    WB_BATCHSCOPE_ID: {neq: dr.WB_BATCHSCOPE_ID},
                    BATCHSCOPE_NAME: dr.BATCHSCOPE_NAME
                }
            })

            ErrorMessage_restate(mp, !_.isEmpty(dups), 'DuplicateName', `Batch Scope name, ${dr.BATCHSCOPE_NAME}, is not unique`)
        }

    }


    static async ValidateDelete(aBO: BatchScopeBO): Promise<void> {
        aBO.DeleteMessageProvider.clearMessages()

    }

}